<div class="w-full mx-auto p-5 space-y-6">
  <!-- Header -->
  <div class="flex flex-wrap justify-between items-center gap-4">
    <div>
      <h1 class="text-2xl font-bold text-gray-800">Carga de Reportes</h1>
      <p class="text-gray-500 mt-1">Sube los reportes diarios de Wompi (CSV) y Plink (Excel) para la conciliación automática.</p>
    </div>
  </div>

  <!-- Daily Task Status Card -->
  <div *ngIf="dailyTaskStatus" 
       class="rounded-xl p-5 border shadow-sm"
       [ngClass]="isTaskComplete() ? 'bg-emerald-50 border-emerald-200' : 'bg-amber-50 border-amber-200'">
    <div class="flex items-center justify-between flex-wrap gap-4">
      <div class="flex items-center gap-4">
        <div [ngClass]="isTaskComplete() ? 'bg-emerald-100' : 'bg-amber-100'" 
             class="p-3 rounded-xl">
          <svg *ngIf="isTaskComplete()" class="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <svg *ngIf="!isTaskComplete()" class="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div>
          <h2 class="text-lg font-semibold" [ngClass]="isTaskComplete() ? 'text-emerald-800' : 'text-amber-800'">
            Estado de la Tarea Diaria
          </h2>
          <p class="text-sm" [ngClass]="isTaskComplete() ? 'text-emerald-600' : 'text-amber-600'">
            {{ formatDate(dailyTaskStatus.taskDate) }}
          </p>
        </div>
      </div>
      <div class="flex items-center gap-6">
        <!-- Wompi Status -->
        <div class="flex items-center gap-2">
          <div [ngClass]="(dailyTaskStatus.wompiUploaded || wompiUploadedLocally) ? 'bg-emerald-500' : 'bg-amber-500'" 
               class="w-3 h-3 rounded-full"></div>
          <span class="text-sm font-medium" [ngClass]="(dailyTaskStatus.wompiUploaded || wompiUploadedLocally) ? 'text-emerald-700' : 'text-amber-700'">
            Wompi: {{ (dailyTaskStatus.wompiUploaded || wompiUploadedLocally) ? 'Completado' : 'Pendiente' }}
          </span>
        </div>
        <!-- Plink Status -->
        <div class="flex items-center gap-2">
          <div [ngClass]="(dailyTaskStatus.plinkUploaded || plinkUploadedLocally) ? 'bg-emerald-500' : 'bg-amber-500'" 
               class="w-3 h-3 rounded-full"></div>
          <span class="text-sm font-medium" [ngClass]="(dailyTaskStatus.plinkUploaded || plinkUploadedLocally) ? 'text-emerald-700' : 'text-amber-700'">
            Plink: {{ (dailyTaskStatus.plinkUploaded || plinkUploadedLocally) ? 'Completado' : 'Pendiente' }}
          </span>
        </div>
        <!-- Overall Status -->
        <div [ngClass]="isTaskComplete() ? 'bg-emerald-100 text-emerald-800 border-emerald-300' : 'bg-amber-100 text-amber-800 border-amber-300'"
             class="px-4 py-2 rounded-lg border font-medium text-sm">
          {{ isTaskComplete() ? 'Tarea Completa ✓' : 'Pendiente' }}
        </div>
      </div>
    </div>
  </div>

  <!-- Upload Grid -->
  <div class="grid md:grid-cols-2 gap-6">
    <!-- Wompi Upload Card -->
    <div class="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <div class="bg-gradient-to-r from-green-600 to-emerald-600 p-4">
        <h3 class="text-lg font-bold text-white flex items-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Reporte Wompi (CSV)
        </h3>
        <p class="text-green-100 text-sm mt-1">Archivo CSV con las transacciones diarias de Wompi</p>
      </div>

      <div class="p-5">
        <!-- Already Uploaded Banner (non-blocking) -->
        <div *ngIf="(dailyTaskStatus?.wompiUploaded || wompiUploadedLocally) && wompiFiles.length === 0 && !wompiMultiUploadResponse"
             class="bg-emerald-50 border border-emerald-200 rounded-lg p-3 mb-4 flex items-center gap-3">
          <svg class="w-5 h-5 text-emerald-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div>
            <p class="text-emerald-700 font-medium text-sm">Reporte Wompi cargado anteriormente</p>
            <p class="text-emerald-600 text-xs">Puedes seguir subiendo más archivos si lo necesitas.</p>
          </div>
        </div>

        <!-- Drop Zone (multi-file, always visible) -->
        <div
          (dragover)="onDragOver($event, 'wompi')"
          (dragleave)="onDragLeave($event, 'wompi')"
          (drop)="onDrop($event, 'wompi')"
          [ngClass]="isDraggingWompi ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-green-500 hover:bg-green-50'"
          class="border-2 border-dashed rounded-xl p-6 text-center transition-all cursor-pointer"
          (click)="wompiInput.click()">
          <input #wompiInput type="file" accept=".csv" multiple (change)="onWompiFileSelected($event)" class="hidden">
          <svg class="w-12 h-12 mx-auto text-gray-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
          </svg>
          <p class="text-gray-700 mb-1">Arrastra y suelta uno o varios archivos CSV aquí</p>
          <p class="text-gray-400 text-sm">o haz clic para seleccionar (selección múltiple habilitada)</p>
        </div>

        <!-- File List -->
        <div *ngIf="wompiFiles.length > 0 && !wompiMultiUploadResponse" class="space-y-3 mt-4">
          <div class="flex items-center justify-between">
            <h4 class="text-sm font-semibold text-gray-700">{{ wompiFiles.length }} archivo(s) seleccionado(s) · {{ formatFileSize(getTotalWompiFilesSize()) }}</h4>
            <button (click)="clearWompiFile()" class="text-xs text-red-500 hover:text-red-700 font-medium transition-colors">
              Limpiar todo
            </button>
          </div>

          <div class="space-y-2 max-h-48 overflow-y-auto">
            <div *ngFor="let file of wompiFiles; let i = index" 
                 class="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2 border border-gray-200">
              <div class="flex items-center gap-2 min-w-0">
                <div class="bg-green-100 p-1.5 rounded-md flex-shrink-0">
                  <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div class="min-w-0">
                  <p class="text-gray-800 text-sm font-medium truncate">{{ file.name }}</p>
                  <p class="text-gray-400 text-xs">{{ formatFileSize(file.size) }}</p>
                </div>
              </div>
              <button (click)="removeWompiFile(i)" class="text-gray-400 hover:text-red-500 transition-colors flex-shrink-0 ml-2">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>

          <!-- Info about async processing -->
          <div class="bg-blue-50 border border-blue-200 rounded-lg p-3">
            <p class="text-blue-700 text-sm flex items-center gap-2">
              <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Los archivos se procesarán en background. Recibirás un email de notificación cuando finalice.
            </p>
          </div>

          <!-- Upload Button -->
          <button 
            (click)="uploadWompiReport()"
            [disabled]="isUploadingWompi"
            class="w-full bg-green-600 hover:bg-green-700 disabled:bg-gray-400 text-white font-semibold py-3 px-6 rounded-lg transition-all flex items-center justify-center gap-2">
            <svg *ngIf="!isUploadingWompi" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
            </svg>
            <div *ngIf="isUploadingWompi" class="animate-spin w-5 h-5 border-2 border-white border-t-transparent rounded-full"></div>
            {{ isUploadingWompi ? 'Encolando...' : 'Procesar ' + wompiFiles.length + ' archivo(s)' }}
          </button>
        </div>

        <!-- Multi-Upload Result -->
        <div *ngIf="wompiMultiUploadResponse" class="mt-4 p-4 rounded-lg bg-emerald-50 border border-emerald-200">
          <div class="flex items-start gap-3">
            <svg class="w-6 h-6 text-emerald-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <p class="text-emerald-700 font-medium">{{ wompiMultiUploadResponse.message }}</p>
              <div class="mt-2 space-y-1">
                <p *ngFor="let fileName of wompiMultiUploadResponse.fileNames" class="text-emerald-600 text-sm flex items-center gap-1">
                  <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                  {{ fileName }}
                </p>
              </div>
              <p class="text-gray-500 text-xs mt-2">Job ID: {{ wompiMultiUploadResponse.jobId }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Plink Upload Card -->
    <div class="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <div class="bg-gradient-to-r from-blue-600 to-indigo-600 p-4">
        <h3 class="text-lg font-bold text-white flex items-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Reporte Plink (Excel)
        </h3>
        <p class="text-blue-100 text-sm mt-1">Archivo Excel con las compensaciones de tarjeta de Plink</p>
      </div>

      <div class="p-5">
        <!-- Already Uploaded Banner (non-blocking) -->
        <div *ngIf="(dailyTaskStatus?.plinkUploaded || plinkUploadedLocally) && plinkFiles.length === 0 && !plinkMultiUploadResponse"
             class="bg-emerald-50 border border-emerald-200 rounded-lg p-3 mb-4 flex items-center gap-3">
          <svg class="w-5 h-5 text-emerald-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div>
            <p class="text-emerald-700 font-medium text-sm">Reporte Plink cargado anteriormente</p>
            <p class="text-emerald-600 text-xs">Puedes seguir subiendo más archivos si lo necesitas.</p>
          </div>
        </div>

        <!-- Drop Zone (multi-file, always visible) -->
        <div
          (dragover)="onDragOver($event, 'plink')"
          (dragleave)="onDragLeave($event, 'plink')"
          (drop)="onDrop($event, 'plink')"
          [ngClass]="isDraggingPlink ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-blue-500 hover:bg-blue-50'"
          class="border-2 border-dashed rounded-xl p-6 text-center transition-all cursor-pointer"
          (click)="plinkInput.click()">
          <input #plinkInput type="file" accept=".xlsx,.xls" multiple (change)="onPlinkFileSelected($event)" class="hidden">
          <svg class="w-12 h-12 mx-auto text-gray-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
          </svg>
          <p class="text-gray-700 mb-1">Arrastra y suelta uno o varios archivos Excel aquí</p>
          <p class="text-gray-400 text-sm">o haz clic para seleccionar (selección múltiple habilitada)</p>
        </div>

        <!-- File List -->
        <div *ngIf="plinkFiles.length > 0 && !plinkMultiUploadResponse" class="space-y-3 mt-4">
          <div class="flex items-center justify-between">
            <h4 class="text-sm font-semibold text-gray-700">{{ plinkFiles.length }} archivo(s) seleccionado(s) · {{ formatFileSize(getTotalPlinkFilesSize()) }}</h4>
            <button (click)="clearPlinkFiles()" class="text-xs text-red-500 hover:text-red-700 font-medium transition-colors">
              Limpiar todo
            </button>
          </div>

          <div class="space-y-2 max-h-48 overflow-y-auto">
            <div *ngFor="let file of plinkFiles; let i = index"
                 class="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2 border border-gray-200">
              <div class="flex items-center gap-2 min-w-0">
                <div class="bg-blue-100 p-1.5 rounded-md flex-shrink-0">
                  <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div class="min-w-0">
                  <p class="text-gray-800 text-sm font-medium truncate">{{ file.name }}</p>
                  <p class="text-gray-400 text-xs">{{ formatFileSize(file.size) }}</p>
                </div>
              </div>
              <button (click)="removePlinkFile(i)" class="text-gray-400 hover:text-red-500 transition-colors flex-shrink-0 ml-2">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>

          <!-- Info about async processing -->
          <div class="bg-blue-50 border border-blue-200 rounded-lg p-3">
            <p class="text-blue-700 text-sm flex items-center gap-2">
              <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Los archivos se procesarán en background. Recibirás un email de notificación cuando finalice.
            </p>
          </div>

          <!-- Upload Button -->
          <button
            (click)="uploadPlinkReport()"
            [disabled]="isUploadingPlink"
            class="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white font-semibold py-3 px-6 rounded-lg transition-all flex items-center justify-center gap-2">
            <svg *ngIf="!isUploadingPlink" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
            </svg>
            <div *ngIf="isUploadingPlink" class="animate-spin w-5 h-5 border-2 border-white border-t-transparent rounded-full"></div>
            {{ isUploadingPlink ? 'Encolando...' : 'Procesar ' + plinkFiles.length + ' archivo(s)' }}
          </button>
        </div>

        <!-- Multi-Upload Result -->
        <div *ngIf="plinkMultiUploadResponse" class="mt-4 p-4 rounded-lg bg-emerald-50 border border-emerald-200">
          <div class="flex items-start gap-3">
            <svg class="w-6 h-6 text-emerald-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <p class="text-emerald-700 font-medium">{{ plinkMultiUploadResponse.message }}</p>
              <div class="mt-2 space-y-1">
                <p *ngFor="let fileName of plinkMultiUploadResponse.fileNames" class="text-emerald-600 text-sm flex items-center gap-1">
                  <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                  {{ fileName }}
                </p>
              </div>
              <p class="text-gray-500 text-xs mt-2">Job ID: {{ plinkMultiUploadResponse.jobId }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Info Section -->
  <div class="bg-blue-50 rounded-xl p-5 border border-blue-200">
    <h3 class="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
      <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      Información sobre la Conciliación
    </h3>
    <div class="grid md:grid-cols-3 gap-6 text-sm">
      <div>
        <h4 class="text-gray-700 font-medium mb-2">Reporte Wompi (CSV)</h4>
        <p class="text-gray-500">Contiene todas las transacciones recibidas del día. El campo "id conciliación" se usa para vincular con el reporte Plink.</p>
      </div>
      <div>
        <h4 class="text-gray-700 font-medium mb-2">Reporte Plink (Excel)</h4>
        <p class="text-gray-500">Contiene las compensaciones de tarjeta con los descuentos aplicados. El "código de autorización" coincide con el id de conciliación de Wompi.</p>
      </div>
      <div>
        <h4 class="text-gray-700 font-medium mb-2">Conciliación Automática</h4>
        <p class="text-gray-500">El sistema ejecuta automáticamente la conciliación todos los días a las 6:00 AM, aplicando los descuentos a los pagos correspondientes.</p>
      </div>
    </div>
  </div>
</div>
